import React from 'react';
import ACHBankCard from '../ach/ACHBankCard';
import { CreditCard } from '../credit-card';
const cardContainer = {
  width: '100%',
  maxWidth: 'calc(var(--fs-hero)*10.6132075)',
  aspectRatio: '16 / 9',
  borderRadius: 'calc(var(--sp-md2)*1.32075)',
  backgroundColor: '#fff',
  display: 'flex',
  alignItems: 'stretch',
  justifyContent: 'stretch',
  '@media (max-width: 650px)': {
    maxWidth: '100%',
    aspectRatio: '3 / 2',
    border: 'none'
  }

};

export const renderPaymentMethods = ({ paymentMethods = [], type = 'card', onEditCard = () => { } }) => {

  switch ((type || '').toLowerCase()) {
    case 'card':
      return (
        <>
          {paymentMethods.map((pm) => (
            <div style={cardContainer}>
              <CreditCard
                key={pm.djstripe_id || pm.id || Math.random()}
                pm={pm}
                selected={!!pm.is_default}
                onSelect={() => onEditCard && onEditCard(pm)}
              />
            </div>
          ))}
        </>
      );
    case 'us_bank_account':
      return (
        <>
          {paymentMethods.map((pm) => (
            <div style={cardContainer}>
              <ACHBankCard
                key={pm.djstripe_id || pm.id || Math.random()}
                pm={{ ...pm, object: 'payment_method' }}
                selected={!!pm.is_default}
                onSelect={() => onEditCard && onEditCard(pm)}
              />
            </div>
          ))}
        </>
      );
    default:
      return null;
  }
};

export default renderPaymentMethods;
